/* Purpose: All Loans from all clients mapped out into cards with LoanID, type, and client name, notes and view client's data button
 * Props: allClients(map)
 *          setAllClients (setState)
 *          allLoans (map)
 *          setAllLoans (setState)
 *          filterSelection (list)
 *          handleViewData (func)
 *          credentials (map)
 *          username
 * Author: R. Markowitz (May 2025)
 * Dev Notes: 
*/

import React, { useMemo } from "react";
import { useState, useEffect } from "react";
import SubmitButton from './Button';
import { Row, Card, Col, Badge, Stack, Form } from 'react-bootstrap';
import NoteModal from "./NoteModal";

const AdminLoans = ({allClients, setAllClients, allLoans, setAllLoans, handleViewData, credentials, username}) => {

    const [showNoteModal, setShowNoteModal] = useState(false)
    const [chosenLoan, setChosenLoan] = useState({});
    // const [filteredLoans, setFilteredLoans] = useState([]);
    const statusOptions = ["Intake", "Processing", "Underwriting", "Approved"]
    const [filterSelection, setFilterSelection] = useState([...statusOptions])

    useEffect(() => {
        window.scrollTo({top: 0, left: 0, behavior: 'smooth' });
    },[])

    // useEffect(() => {
    //     if (allLoans && filterSelection){
    //         let tempLoans = [...allLoans]
    //         tempLoans = tempLoans.filter((loan) => filterSelection.includes(loan.Status))
    //         setFilteredLoans(tempLoans)
    //     }
    // },[allLoans, filterSelection])

    const filteredLoans = useMemo(() => {
        if (allLoans && filterSelection){
            let tempLoans = [...allLoans]
            tempLoans = tempLoans.filter((loan) => filterSelection.includes(loan.Status))
            return tempLoans
        }
    },[allLoans, filterSelection])

    // When a filter option is selected or deselected update filterSelection accordingly
    const handleFilterChange = (value) => {
        let tempFilterSelection = [...filterSelection]
        const index = tempFilterSelection.indexOf(value)

        if (index > -1){
            tempFilterSelection.splice(index, 1)
        }else{
            tempFilterSelection.push(value)
        }

        setFilterSelection(tempFilterSelection)
            
    }

    const handleViewNotes = (loan) => {
        setChosenLoan(loan);
        setShowNoteModal(true);
    }

    return (
        <Row xs={1} sm = {2} md={3} className="g-4 m-5"> 
            {filterSelection && (
            <Col xs = {12} sm = {12} md = {12} lg = {12} xl= {12}>
                <Form>
                    <Form.Group>
                        <Form.Label className = "me-3">Filter Loans By Status: </Form.Label>                
                        {statusOptions.map((option, index) => (
                            <Form.Check
                                inline
                                key = {index}
                                type = "checkbox"
                                value = {option}
                                checked = {filterSelection.includes(option)}
                                onChange={(event) => {handleFilterChange(event.target.value)}}
                                label = {option}
                            />
                        ))}
                    </Form.Group>
                </Form>
            </Col>)}
            {filteredLoans && filteredLoans.map((loan, index) => (
                <Col key = {index} className="d-flex col-sm ">
                    <Card className = "p-2 flex-fill border-10" border = {loan.Status && loan.Status == "Approved"?"success":"light"}>
                        <Card.Title>
                            <Stack direction = "horizontal" gap = {2}>
                                <>{loan.LoanID}</>
                                <>{loan.isNew && (<Badge className = 'ms-auto' pill bg="danger">New</Badge>)}</>
                            </Stack>
                        </Card.Title>
                        <p>
                            Type: {loan.LoanType}<br />
                            Client: {loan.ClientName}
                        </p>
                        <Badge pill bg="success" className={loan.Status == "Approved"?"show":"hide"}>Approved</Badge>
                        <div className="text-align-center mt-auto w-100"><SubmitButton className = "" text = "View Client's Data" onClick = {() => handleViewData(allClients[loan.ClientIndex])} width = "90"/></div>
                        <div className="text-align-center mt-auto w-100"><SubmitButton className = "" text = "Notes" onClick = {() => handleViewNotes(loan)} width = "90"/></div>
                    </Card>
                </Col>
            ))}

            {showNoteModal && (
                <NoteModal
                    credentials = {credentials}
                    username = {username}
                    loan = {chosenLoan}
                    setLoan = {setChosenLoan}
                    allClients = {allClients}
                    setAllClients = {setAllClients}
                    allLoans = {allLoans}
                    setAllLoans = {setAllLoans}
                    isAdmin = {true}
                    onHide = {() => setShowNoteModal(false)}
                />
            )}
        </Row>  
    )
};

export default AdminLoans;